var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 20.75V43.25H43.25V20.75H20.75ZM38.75 38.75H25.25V25.25H38.75V38.75Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 25.25V20.75H54.5V14C54.5 12.8 54.02 11.66 53.18 10.82C52.34 9.98 51.2 9.5 50 9.5H43.25V0.5H38.75V9.5H25.25V0.5H20.75V9.5H14C12.8 9.5 11.66 9.98 10.82 10.82C9.98 11.66 9.5 12.8 9.5 14V20.75H0.5V25.25H9.5V38.75H0.5V43.25H9.5V50C9.5 51.2 9.98 52.34 10.82 53.18C11.66 54.02 12.8 54.5 14 54.5H20.75V63.5H25.25V54.5H38.75V63.5H43.25V54.5H50C51.2 54.5 52.34 54.02 53.18 53.18C54.02 52.34 54.5 51.2 54.5 50V43.25H63.5V38.75H54.5V25.25H63.5ZM50 50H14V14H50V50Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcController);
export default __webpack_public_path__ + "static/media/ic-controller.36df40b8ac42f1b6e9c63ddc05efbdcf.svg";
export { ForwardRef as ReactComponent };